import { Tabs } from '@orbita-ui/core';
import Page from 'components/page';
import SettingsGroups from 'features/settings/groups/groups';
import SettingsUsers from 'features/settings/users/users';

import SettingsIssuers from 'features/settings/issuers/issuers';
import useAuthService from 'hooks/useAuthService';
import React from 'react';
import { RealmRoles } from '../constants';

const Settings = () => {
  const { userHasRole } = useAuthService();

  const tabs = [
    {
      label: 'Plataforma',
      content: <SettingsIssuers />,
      role: [RealmRoles.ContactCenter, RealmRoles.RiskManagement, RealmRoles.IssuerImpersonate],
    },
    {
      label: 'Mis Usuarios',
      content: <SettingsUsers />,
      role: [RealmRoles.UsersAllRead],
    },
    {
      label: 'Mis Grupos',
      content: <SettingsGroups />,
      role: [RealmRoles.GroupsAllRead],
    },
  ].filter((tab) => userHasRole(tab.role));

  return <Page title={`Configuraciones`}>{tabs.length > 0 && <Tabs tabs={tabs} />}</Page>;
};

export default Settings;
